var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoPlayGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 20,
    viewBox: "0 0 34 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369",
    transform: "translate(-217 -198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_239",
    "data-name": "Rectangle 239",
    transform: "translate(217 198)",
    fill: "#fff",
    stroke: "#00c22d",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 20,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 19,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M6.9,8.036v-3.5a.992.992,0,0,1,1.487-.865L11.392,5.42,14.4,7.171a1,1,0,0,1,0,1.73l-3.01,1.751L8.383,12.4A.992.992,0,0,1,6.9,11.538Z",
    transform: "translate(223.104 199.964)",
    fill: "#00c22d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayGreen);
export default __webpack_public_path__ + "static/media/videoPlayGreen.2ad145f7d8f9a8e51320b89ba6fb9cca.svg";
export { ForwardRef as ReactComponent };